<div style="width: 100%;background-color:#dee8f4;padding: 10px">
  <form #loginForm="ngForm">
    <div *ngFor="let group of validFilters" style="float: left;clear:none;width:100%">
      <h4 mat-line>{{group.title}}</h4>
      <div *ngFor="let input of group.inputs" [ngSwitch]="input.type">
        <div *ngSwitchCase="'checkbox'" style="float: left;clear: left;margin-left:1%">
          <div style="float:left;clear:none;padding-right:5px;padding-top:2px">{{('oportunitats.estats.'+input.name) | translate}}</div>
          <mat-checkbox *ngFor="let value of input.values" style="margin-right: 1em;"
            [(ngModel)]="filterModel[value.name]" name="{{value.name}}"
            ngDefaultControl>
              {{('oportunitats.estats.'+value.name) | translate}}
          </mat-checkbox>
        </div>
        <div *ngSwitchCase="'text'" style="float:left;clear:none;width:100%">
          <mat-form-field *ngFor="let value of input.values" style="float:left;clear:none">
           <input matInput
            style="flex-grow: 1; flex-basis: 0;"
            [attr.list]="value.autocomplete ? value.autocomplete : null "
            name="{{value.name}}" [(ngModel)]="filterModel[value.name]"
            placeholder="{{('oportunitats.filtrar.'+value.name) | translate}}" 
            ngDefaultControl/>
          </mat-form-field>
          <div style="float:left;clear:none;width:150px">
             <button matTooltip="{{'common.cerca' | translate}}" attr.aria-label="{{'common.cerca'}}" matTooltipClass="tooltip-style" mat-button (click)="sendActiveFilters()" style="min-width:45px;padding:10px">
             <mat-icon color="primary" style="font-size: 24px">search</mat-icon>
             </button>
             <button matTooltip="{{'common.reinicia' | translate}}" attr.aria-label="{{'common.reinicia' | translate}}" matTooltipClass="tooltip-style" mat-button (click)="resetActiveFilters()" style="min-width:45px;padding:10px">
            <mat-icon color="primary" style="font-size: 24px">autorenew</mat-icon>
             </button>
          </div>
        </div>
        <label *ngSwitchCase="'select'" style="max-width: 33%; display: flex; flex-grow: 1; flex-basis: 0;">
          {{input.description}}
          <mat-select [(ngModel)]="filterModel[input.name]" name="{{input.name}}" ngDefaultControl>
            <mat-option *ngFor="let option of input.options"  value="{{option.value}}">{{option.text}}</mat-option>
          </mat-select>
        </label>
      </div>
    </div>
  </form>
</div>

<div *ngFor="let dataList of dataLists">
  <datalist id="{{dataList.id}}" *ngIf="dataList.id !== 'tecnicMcrit'">
    <option title="{{option.text}}" *ngFor="let option of dataList.options | async" value="{{option.text}}">{{option.text}}</option>
  </datalist>
  <datalist id="{{dataList.id}}" *ngIf="dataList.id == 'tecnicMcrit'">
    <option *ngFor="let option of dataList.options | async" value="{{option.text}}">{{option.text}}</option>
  </datalist>
</div>